import * as api from 'app/resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchTiersDictionaryRequest = () => ({
  type: actionTypes.FETCH_TIERS_DICTIONARY_REQUEST,
});

export const fetchTiersDictionarySuccess = (dictionary) => ({
  type: actionTypes.FETCH_TIERS_DICTIONARY_SUCCESS,
  dictionary,
});

export const fetchTiersDictionaryFailure = () => ({
  type: actionTypes.FETCH_TIERS_DICTIONARY_FAILURE,
});

export const fetchTiersDictionary = () => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;

    dispatch(fetchTiersDictionaryRequest());
    const dictionary = await api.fetchTiersDictionary(locale);
    dispatch(fetchTiersDictionarySuccess(dictionary));
  } catch (error) {
    console.error('FETCH_TIERS_DICTIONARY', error);
    dispatch(fetchTiersDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/tiers-dictionary.actions.js